import type { ComponentPropsWithoutRef } from 'react'

import { cn } from '@morpho-org/ui-v6/utils'

/**
 * Header row wrapper. `isExpanded` is accepted for API parity with the previous
 * Emotion styled component (it did not affect styling).
 */
export const CardNetApyHeaderWrapper = ({
  // Destructured out (not `...props`-spread) so it never lands on the DOM div.
  isExpanded: _isExpanded,
  className,
  ...props
}: ComponentPropsWithoutRef<'div'> & { isExpanded?: boolean }) => (
  <div
    className={cn(
      'flex',
      cn(
        'p-md items-center justify-between',
        // down('m'): pt 32px, px 32px
        'max-lg:px-lg max-lg:pt-lg',
        // down('xs'): pt 32px, px 20px
        'max-sm:px-md max-sm:pt-lg',
        className
      )
    )}
    {...props}
  />
)

export const CardNetApyRoot = ({ className, ...props }: ComponentPropsWithoutRef<'div'>) => (
  <div
    className={cn(
      'bg-muted h-full w-full overflow-hidden rounded-[20px] text-center',
      // down('m'): bg bloc
      'max-lg:bg-card',
      className
    )}
    {...props}
  />
)

export const CardNetApyInnerWrapper = ({
  className,
  ...props
}: ComponentPropsWithoutRef<'div'>) => (
  <div className={cn('flex', cn('h-full flex-col pb-0', className))} {...props} />
)

export const CardApyTextMessage = ({ className, ...props }: ComponentPropsWithoutRef<'span'>) => (
  <span
    className={cn(
      'text-2xs text-secondary-foreground gap-lg p-sm flex h-[340px] flex-col items-center justify-center',
      // down('m'): height auto, pb 32px, px 20px
      'max-lg:h-auto max-lg:px-md max-lg:pb-lg',
      className
    )}
    {...props}
  />
)
